import React, { PropsWithChildren } from 'react';

import { TabbedNav } from '../components/tabbed-nav/TabbedNav.view';

import { useEntitiesTabs } from '../hooks/useSystemsTabs.hook';

import type { DataEntityTypes } from '../types/common.types';

export const EntitiesTabs: React.FC<
  PropsWithChildren<{ subId: string; entityType: DataEntityTypes }>
> = ({ subId, entityType, children }) => {
  const tabs = useEntitiesTabs(entityType, subId);

  return <TabbedNav nav={tabs}>{children}</TabbedNav>;
};
